import $ from 'jquery'; 
window.$ = window.jQuery = $;
import Quill from 'Quill';
import Swal from 'sweetalert2';

// ************ Hover Start*************** //
let  quill = null;
var $cjsType ,$cjsParam , $curEle ,$curEleName, $curParentEle ,$curEleWidth ,$cjs_badge_div ,CjsTxt,$inputTxt;

function cjs_change_text(el,type){
   /* alert("data");*/

     CjsTxt = '';
     let cjsTop,cjsLeft
    if(type==1){
        el.addClass('cjs-badge-del');
        $cjs_badge_div = '<div class="cjs-badge" ><div class="cjs-badge-del-text">Delete</div> </div>';
         cjsTop = (el.offset().top - 15) <= 0 ? 0 : ((el.offset().top + 5)) ;
         cjsLeft = (el.offset().top ) <= 0 ? el.offset().left + el.width()  : (el.offset().left + el.width() + 30);
       
    }else if(type==2){
        el.addClass('cjs-badge-copy');
        $cjs_badge_div = '<div class="cjs-badge" ><div class="cjs-badge-copy-text">Copy</div></div>';
         cjsTop = (el.offset().top - 15) <= 0 ? 0 : ((el.offset().top + 5)) ;
         cjsLeft = (el.offset().top ) <= 0 ? el.offset().left + el.width()  : (el.offset().left + el.width() + 30);
       
    }else if(type==3){
        el.addClass('cjs-badge-copy-del');
        $cjs_badge_div = '<div class="cjs-badge cjs-badge-copy-del-div " ><div class="cjs-badge-copy-text">Copy</div> <div class="cjs-badge-del-text">Delete</div> </div>';
         cjsTop = (el.offset().top - 15) <= 0 ? 0 : ((el.offset().top + 5)) ;
         cjsLeft = (el.offset().top ) <= 0 ? el.offset().left + el.width()  : (el.offset().left + el.width() - 15);
       
    }else{
         $cjs_badge_div = '<div class="cjs-badge"><div class="cjs-badge-name"></div> </div>';
         cjsTop = (el.offset().top - 15) <= 0 ? 0 : ((el.offset().top - 20)) ;
         cjsLeft = (el.offset().top ) <= 0 ? el.offset().left + 0 : el.offset().left - 5;
       
    }
    $curEle = el;
    
    
    $("body .cjs-badge:first").remove();
    $('body').prepend($cjs_badge_div);
    $('.cjs-badge-name').text(CjsTxt);
    $('.cjs-badge').show();
    $('.cjs-badge').css({"top":cjsTop+"px", "left":cjsLeft+"px"});
}


function cjs_text_mouse_enter(e, ele,type=0){
    $curEleHover = e.target;
    $curEleNameHover = $curEleHover.nodeName.toLowerCase();
    if( $curEleNameHover === 'a' ) {
        $hrefVal = e.target.getAttribute('href');
        if($hrefVal.charAt(0)!='#'){
            ele.attr('href', '#'+$hrefVal);
        }
    }
    if($('body').hasClass('cjs-selected-item')){

    }else{
        if(type!=0){
            cjs_change_text(ele,type);
        }else{
            if(ele.hasClass('cjs-change-title')){
                cjs_change_text(ele,type);
            }
        }
        
     }

}


function cjs_text_mouse_leave(e, ele,type=0){

    $curEleHover = e.target;
        $curEleNameHover = $curEleHover.nodeName.toLowerCase();
        if( $curEleNameHover === 'a' ) {
            $hrefVal = e.target.getAttribute('href');
            if($hrefVal.charAt(0)!='#'){
                ele.attr('href',$hrefVal.substr(1));
            }
        }
       if($('body').hasClass('cjs-selected-item')){

        }else{
            if(type==1){
                ele.removeClass('cjs-badge-del'); 
            }else if(type==2){
                ele.removeClass('cjs-badge-copy'); 
            }else if(type==3){
                ele.removeClass('cjs-badge-copy-del'); 
            } 
            $('.cjs-badge').remove();
        }

}
    
$(document).ready(function(){
    /*$saveTemplateHtml = '<div class="cjs-loader"><div class="cjs-loader-item">Loading.....</div></div><div class="cjs-save-template-div"><button class="cjs-save-btn">Save Template</button></div>';

    $("body").prepend($saveTemplateHtml);*/
});            

 $(document).on({
    mouseenter: function (e) {
        cjs_text_mouse_enter(e, $(this));
    },
    mouseleave: function (e) {
       cjs_text_mouse_leave(e, $(this));
    }
}, ".cjs-change-title"); 


$(document).on({
    mouseenter: function (e) {
        cjs_text_mouse_enter(e, $(this),1);
    },
    mouseleave: function (e) {
       cjs_text_mouse_leave(e, $(this),1);
    }
}, ".cjs-change-title-with-del"); 


$(document).on({
    mouseenter: function (e) {
        cjs_text_mouse_enter(e, $(this),2);
    },
    mouseleave: function (e) {
       cjs_text_mouse_leave(e, $(this),2);
    }
}, ".cjs-change-title-with-copy"); 


$(document).on({
    mouseenter: function (e) {
        cjs_text_mouse_enter(e, $(this),3);
    },
    mouseleave: function (e) {
       cjs_text_mouse_leave(e, $(this),3);
    }
}, ".cjs-change-title-copy-del"); 
// ************ Hover Ends *************** //




function cjs_delete(ele){
    ele.remove();

}
function cjs_copy(ele)
{
    if(ele.hasClass('cjs-change-text-copy-del'))
    {
        ele.clone().insertAfter(ele);
    }
    else
    {
        ele.addClass('cjs-change-text-copy-del').clone().insertAfter(ele);
        ele.removeClass('cjs-change-text-copy-del');
    }
    
}

$(document).on('click', '.cjs-badge-del', function(e) {
    cjs_delete($curEle);
});

$(document).on('click', '.cjs-badge-copy', function(e) {
    cjs_copy($curEle);
});
// cjs-change-title
$(document).on('click', '.cjs-change-title', function(e) 
{
    let type = $(this).data('type');
    let invid = $(this).data('invid');
    let category = $(this).data('category');
    let td = $(this).data('testindex');
    let approvaltype = $(this).data('approvaltype');
    e.stopPropagation();
    if($('body').hasClass('cjs-selected-item')){
        $($curEle).text($('.cjs-selected').val()).show();
        $('body').removeClass('cjs-selected-item');
        $('.cjs-badge').remove();
        $('.cjs-selected').remove();
    
    }
    $cjsType = e.target.getAttribute('cjs-badge-type');
    $cjsParam = e.target.getAttribute('cjs-param');
    $curEle = e.target;
    $curEleName = $curEle.nodeName.toLowerCase();
    $curParentEle =  $curEle.parentElement;
    $curEleWidth = $curEle.offsetWidth;
    $('body').addClass('cjs-selected-item');
    CjsTxt = '';
    
    if( $curEleName === 'a' ) {
        e.stopImmediatePropagation();
        e.preventDefault();
    }
    if ($curEleName !== 'input' && $curEleName !== 'img')
    {

        if(type == 'Title' || type == 'Tagline')
        {
			$inputTxt = '<input type="text" onfocus="this.select()" class="cjs-selected titletext" data-invid="'+invid+'" data-category="'+category+'" data-approvaltype="'+approvaltype+'" data-type="'+type+'"data-testindex="'+td+'"  style="width:100%;text-align:center" value="'+$($curEle).text()+'"/>';
            $($curEle).hide();
            $($curEle).after($inputTxt);
        }
        else if((type == 'Number'))
        {
            $inputTxt = '<input type="text" onfocus="this.select()" class="cjs-selected titletext" data-invid="'+invid+'" data-category="'+category+'" data-approvaltype="'+approvaltype+'" data-type="'+type+'"data-testindex="'+td+'"  style="width:100%;text-align:center" value="'+$($curEle).text()+'"/>';
           
            $($curEle).hide();
            $($curEle).after($inputTxt);
        }
        else if((type == 'Website'))
        {
            $inputTxt = '<input type="text" onfocus="this.select()" class="cjs-selected titletext" data-invid="'+invid+'" data-category="'+category+'" data-approvaltype="'+approvaltype+'" data-type="'+type+'"data-testindex="'+td+'"  style="width:100%;text-align:center" value="'+$($curEle).text()+'"/>';
           
            $($curEle).hide();
            $($curEle).after($inputTxt);
        }
        else
        {
            $('#descriptionbox').modal("show");
        }
        if($(this).find('.cjs-change-title').length){
            CjsTxt = '';
        }
        let cjsTop, cjsLeft = 0;
        if($(this).offset().top < 30)
        {
             cjsTop = ($(this).offset().top + $(this).height() + 25) ;
             cjsLeft = ($(this).offset().top ) <= 0 ? $(this).offset().left + 0 : $(this).offset().left - 5;
        
        }
        else
        {
             cjsTop = ($(this).offset().top - 35) <= 0 ? 0 : (($(this).offset().top - 45)) ;
             cjsLeft = ($(this).offset().top ) <= 0 ? $(this).offset().left + 0 : $(this).offset().left - 5;
        
        }
        $("body .cjs-badge:first").remove();
        $('body').prepend($cjs_badge_div);
        $('.cjs-badge-name').text(CjsTxt);
        $('.cjs-badge').show();
        $('.cjs-badge').css({"top":cjsTop+"px", "left":cjsLeft+"px"});
    }
});


// cjs-change-title
$(document).on('change', '.titletext',function(e) 
{
    let titleData = $(".cjs-selected").val();
    let type = $(".cjs-selected").data('type');
   
    let approvaltype = $(".cjs-selected").data('approvaltype');
    let category = $(".cjs-selected").data('category');
    let invention_id = $(".cjs-selected").data('invid');
    let testindex = $(".cjs-selected").data('testindex');
    let test_rows = [];
    let total_blocks = $(".testimonialblock");
    if(titleData == '')
    {
        Swal.fire({
            title: "Please provide description",
            icon: 'warning',
            confirmButtonText: 'OK'
        });
    }
    else
    {
        if(type == 'Title' || type == 'Tagline' && titleData.match(/^[\x00-\x7F]*$/) != null)
        {
            if(category == 'inventor')
            {
                localStorage.setItem(type,titleData);
                localStorage.setItem('inventionkey',true);
                if(approvaltype == 1)
                {
                    Swal.fire({
                        title: "If you change invention name, your assigned URL won't change. Please contact admin if you'd like to get that changed.",
                        icon: 'warning',
                        confirmButtonText: 'OK'
                    });
                }
                
            }   
            else
            {
                localStorage.setItem('vendorkey',true);
                if(approvaltype == 1)
                {
                    Swal.fire({
                        title: "If you change the company name, your assigned URL won't change. Please contact the admin if you'd like to have it changed.",
                        icon: 'warning',
                        confirmButtonText: 'OK'
                    });
                    $(document).ajaxSend(function() 
                    {
                        $("#overlay").fadeIn(300);　
                    });
                    $.ajax(
                    {
                        headers: {
                            'X-CSRF-Token': $('meta[name="csrf-token"]').attr('content')
                        },
                        url:  '/admin/vendor/url/email',
                        type: 'POST',
                        data:   {
                                    'title' :titleData,
                                },
                        success: function(response)
                        {},
                        error: function(jqXHR, textStatus, errorThrown, response)
                        {
                            Swal.fire({
                                title: 'Internal error: ' + errorThrown,
                                icon: 'danger',
                                confirmButtonText: 'OK'
                            });
                        }
                    }).done(function() 
                    {
                        setTimeout(function() 
                        {
                            $("#overlay").fadeOut(300);
                        }, 500);
                    });
                }
                localStorage.setItem(type,titleData);
            }     
            $($curEle).text($('.cjs-selected').val()).show();
            $('body').removeClass('cjs-selected-item');
            $('.cjs-badge').remove();
            $('.cjs-selected').remove();
        }
        else if(type == 'Number' && titleData.match(/^[\x00-\x7F]*$/) != null)
        {
            if(category == 'inventor')
            {
                localStorage.setItem(type,titleData);
                if(approvaltype == 1)
                {
                    Swal.fire({
                        title:"If you change invention name, your assigned URL won't change. Please contact admin if you'd like to get that changed.",
                        icon: 'warning',
                        confirmButtonText: 'OK'
                    });
                }
                
            }   
            else
            {
                if(approvaltype == 1)
                {
                    Swal.fire({
                        title:"If you change the company name, your assigned URL won't change. Please contact the admin if you'd like to have it changed.",
                        icon: 'warning',
                        confirmButtonText: 'OK'
                    });
                }
                localStorage.setItem(type,titleData);
                
            }     
            $($curEle).text($('.cjs-selected').val()).show();
            $('body').removeClass('cjs-selected-item');
            $('.cjs-badge').remove();
            $('.cjs-selected').remove();
        }
        else if(type == 'Website' && titleData.match(/^[\x00-\x7F]*$/) != null)
        {
            if(category == 'inventor')
            {
                localStorage.setItem(type,titleData);
                if(approvaltype == 1)
                {
                    Swal.fire({
                        title:"If you change invention name, your assigned URL won't change. Please contact admin if you'd like to get that changed.",
                        icon: 'warning',
                        confirmButtonText: 'OK'
                    });
                }
                
            }   
            else
            {
                if(approvaltype == 1)
                {
                    Swal.fire({
                        title:"If you change company name, your assigned URL won't change. Please contact admin if you'd like to get that changed.",
                        icon: 'warning',
                        confirmButtonText: 'OK'
                    });
                }
                localStorage.setItem(type,titleData);
                
            }     
            $($curEle).text($('.cjs-selected').val()).show();
            $('body').removeClass('cjs-selected-item');
            $('.cjs-badge').remove();
            $('.cjs-selected').remove();
        }
        else
        {
            Swal.fire({
                title: "Special characters except (@, #, $, % , ^, &, *, _) are not allowed",
                icon: 'warning',
                confirmButtonText: 'OK'
            });
            localStorage.removeItem(type);
        }
    	
    }




  
});
function testdata(id,data,type)
{
    let test_rows = [];
    test_line = {};
    if(type== 'testcomapny')
    {
       test_line.testcompanyname = data;
    }
    else if(type== 'testauthor')
    {
       test_line.testauthor = data;
    }
    else if(type== 'testdesc')
    {
       test_line.testdesc = data;
    }
    else
    {

    }
    test_rows.push(test_line);
    localStorage.setItem("test",JSON.stringify(test_rows));
   
}

$(document).on('click', '.cjs-cross',function(e) {
    $('body').removeClass('cjs-selected-item')
    $($curEle).show();
    $('.cjs-badge').remove();
    $('.cjs-selected').remove();
});


$(document).on('click', '.cjs-save-btn',function(e) {
    var cjs_params_array = {};
    alert($(".cjs-change-title").length);
    $(".cjs-change-title").each(function() {
        var $cjsParamKey = $(this).attr('cjs-param');
        var $cjsParamVal = $(this).text();
        $cjsParamKey = $(this).attr('cjs-param');
        cjs_params_array[$cjsParamKey] = $cjsParamVal;
        
    });
    if(Object.keys(cjs_params_array).length){
        $.ajax({
            type: 'POST',
            url: "index.php",
            data: JSON.stringify(cjs_params_array),
            beforeSend:function(){
                $('.cjs-loader').show();
            },
            success: function(resultData) { alert("Save Complete") }
      });
    }
    
});



$(document).on("click", ".descsave", function()
{
    let quilldesc = JSON.stringify(quill.getContents());
    let  desc= quill.root.innerHTML;
    $('#desc').html(desc);
    localStorage.setItem("Description",quilldesc);
    localStorage.setItem('inventionkey',true);
    localStorage.setItem('vendorkey',true);


    $('#descriptionbox').modal("hide");
});


$(document).ready(function() 
{
    quill = new Quill('.editor', 
    {
        modules:{
                    toolbar: 
                    [
                        [{ header: [1, 2, 3, 4, 5, 6, false]  }],
                        [{ 'color': [] }, { 'background': [] }],
                        [{ 'list': 'ordered'}, { 'list': 'bullet' }],
                        ['bold', 'italic', 'underline', 'link'],
                        ['image'],
                        ['video'],
                    ]
                },
                placeholder: 'Content here...',
                theme: 'snow'  
    }); 
    let name = $('#editorDescriptionContent').val();
    if(name != '' && name != ' ')
    {
        quill.setContents(JSON.parse(name));
    }
});


$(document).on("click", "#preview", function(e)
{
    e.preventDefault();
    $("#description").val(JSON.stringify(quill.getContents()));
    $("#type").val('preview');
    $('#AddContent').submit();

});
$(document).on("submit", "#editcontent", function(e)
{
    e.preventDefault();
    $("#description").val(JSON.stringify(quill.getContents()));
    this.submit();
});

$(document).on("click", "#exit", function(e)
{
    e.preventDefault();
    $("#description").val(JSON.stringify(quill.getContents()));
    $("#type").val('exit');
    $('#AddContent').submit();
});
$(document).on("click", "#editpreview", function(e)
{
    e.preventDefault();
    $("#description").val(JSON.stringify(quill.getContents()));
    $("#type").val('preview');
    $('#editcontent').submit();
});
$(document).on("click", "#editexit", function(e)
{
    e.preventDefault();
    $("#description").val(JSON.stringify(quill.getContents()));
    $("#type").val('exit');
    $('#editcontent').submit();
});





//page
$(document).on("click", "#pagepreview", function(e)
{
    e.preventDefault();
    $("#description").val(JSON.stringify(quill.getContents()));
    $("#type").val('preview');
    $('#AddPageContent').submit();

});
$(document).on("submit", "#pageeditcontent", function(e)
{
    e.preventDefault();
    $("#description").val(JSON.stringify(quill.getContents()));
    this.submit();
});

$(document).on("click", "#pageexit", function(e)
{
    e.preventDefault();
    $("#description").val(JSON.stringify(quill.getContents()));
    $("#type").val('exit');
    $('#AddPageContent').submit();
});

